/** Column sorters for the Sonic Survey list (antd Table `sorter`). Rows come from fetchAll. */

const STATUS_ORDER = { active: 0, draft: 1, closed: 2 };

const time = (value) => {
  const ms = value ? new Date(value).getTime() : 0;
  return Number.isNaN(ms) ? 0 : ms;
};

export const SURVEY_LIST_SORTERS = {
  format: (a, b) =>
    String(a.badgeLabelKey || a.format || "").localeCompare(String(b.badgeLabelKey || b.format || "")),
  name: (a, b) => String(a.name || "").localeCompare(String(b.name || ""), "tr", { sensitivity: "base" }),
  status: (a, b) => (STATUS_ORDER[a.status] ?? 3) - (STATUS_ORDER[b.status] ?? 3),
  // Voice surveys have no link to view; they sort below any link survey.
  linkStats: (a, b) => (a.linkStats ? a.linkStats.views : -1) - (b.linkStats ? b.linkStats.views : -1),
  responseCount: (a, b) => (a.responseCount || 0) - (b.responseCount || 0),
  // Never answered sorts as oldest.
  lastResponseAt: (a, b) => time(a.lastResponseAt) - time(b.lastResponseAt),
  createdAt: (a, b) => time(a.createdAt) - time(b.createdAt),
};

// Never back to "unsorted": the third click returns to the first direction.
export const TEXT_SORT_DIRECTIONS = ["ascend", "descend", "ascend"];
export const NUMBER_SORT_DIRECTIONS = ["descend", "ascend", "descend"];
